import { API_URL } from 'constants/Api'

export const ASSETS = {
    images: `${API_URL}/images/`,
    FILES:  `${API_URL}/files/`,
}